import * as ActionType from "./comingSoonVenue.type";

const initialState = {
  venues: [],
};

export const comingSoonVenueReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_COMING_SOON_VENUES:
      return { ...state, venues: action.payload };
    case ActionType.ADD_COMING_SOON_VENUE:
      return { ...state, venues: [action.payload, ...state.venues] };
    case ActionType.UPDATE_COMING_SOON_VENUE:
      return {
        ...state,
        venues: state.venues.map((v) =>
          v._id === action.payload._id ? action.payload : v
        ),
      };
    case ActionType.DELETE_COMING_SOON_VENUE:
      return {
        ...state,
        venues: state.venues.filter((v) => v._id !== action.payload),
      };
    default:
      return state;
  }
};
